require("src/decidim/voca/voca");
